import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import { Result } from 'antd';

const productRoutes = [
  {
    path: '/home/industry/company',
    name: 'company',
    component: lazy(() => import('@/pages/Search/Company')),
  },
  {
    path: '/home/industry/patent',
    name: 'patent',
    component: lazy(() => import('@/pages/Search/Patent')),
  }, {
    path: '/home/industry/investment',
    name: 'investment',
    component: lazy(() => import('@/pages/Search/Investment')),
  }, {
    path: '/home/industry/academy',
    name: 'academy',
    component: lazy(() => import('@/pages/Search/Academy')),
  }, {
    path: '/home/industry/garden',
    name: 'garden',
    component: lazy(() => import('@/pages/Search/Garden')),
  }, {
    path: '/home/industry/policy',
    name: 'policy',
    component: lazy(() => import('@/pages/Search/Policy')),
  }, {
    path: '/home/industry/researchReport',
    name: 'researchReport',
    component: lazy(() => import('@/pages/Search/ResearchReport')),
  }, {
    path: '/home/industry/industryAnalysis/industryChainGraph',
    name: 'industryChainGraph',
    component: lazy(() => import('@/pages/Industry/components/IndustryAnalysis/IndustryChainGraph')),
  }, {
    path: '/home/industry/industryAnalysis/arealDistribution',
    name: 'arealDistribution',
    component: lazy(() => import('@/pages/Industry/components/IndustryAnalysis/ArealDistribution')),
  }, {
    path: '/home/industry/industryAnalysis/stockFunding',
    name: 'stockFunding',
    component: lazy(() => import('@/pages/Industry/components/IndustryAnalysis/StockFunding')),
  }, {
    path: '/home/industry/industryAnalysis/technicalInnovation',
    name: 'technicalInnovation',
    component: lazy(() => import('@/pages/Industry/components/IndustryAnalysis/TechnicalInnovation')),
  }, {
    path: '/home/industry/industryAnalysis/listedCompany',
    name: 'listedCompany',
    component: lazy(() => import('@/pages/Industry/components/IndustryAnalysis/ListedCompany')),
  }, {
    path: '/home/industry/industryAnalysis/ranking',
    name: 'ranking',
    component: lazy(() => import('@/pages/Industry/components/IndustryAnalysis/Ranking')),
  },
];

const cityRoutes = [
  {
    path: '/home/city/company',
    name: 'company',
    component: lazy(() => import('@/pages/Search/Company')),
  }, {
    path: '/home/city/patent',
    name: 'patent',
    component: lazy(() => import('@/pages/Search/Patent')),
  }, {
    path: '/home/city/investment',
    name: 'investment',
    component: lazy(() => import('@/pages/Search/Investment')),
  }, {
    path: '/home/city/academy',
    name: 'academy',
    component: lazy(() => import('@/pages/Search/Academy')),
  }, {
    path: '/home/city/garden',
    name: 'garden',
    component: lazy(() => import('@/pages/Search/Garden')),
  }, {
    path: '/home/city/policy',
    name: 'policy',
    component: lazy(() => import('@/pages/Search/Policy')),
  }, {
    path: '/home/city/researchReport',
    name: 'researchReport',
    component: lazy(() => import('@/pages/Search/ResearchReport')),
  }, {
    path: '/home/city/operationMonitor/regionDistribution',
    name: 'regionDistribution',
    component: lazy(() => import('@/pages/City/components/OperationMonitor/RegionDistribution')),
  }, {
    path: '/home/city/operationMonitor/industryDistribution',
    name: 'industryDistribution',
    component: lazy(() => import('@/pages/City/components/OperationMonitor/IndustryDistribution')),
  }, {
    path: '/home/city/operationMonitor/innovateElement',
    name: 'innovateElement',
    component: lazy(() => import('@/pages/City/components/OperationMonitor/InnovateElement')),
  }, {
    path: '/home/city/operationMonitor/equityFinance',
    name: 'equityFinance',
    component: lazy(() => import('@/pages/City/components/OperationMonitor/EquityFinance')),
  }, {
    path: '/home/city/operationMonitor/statisticAnalysis',
    name: 'statisticAnalysis',
    component: lazy(() => import('@/pages/City/components/OperationMonitor/StatisticAnalysis')),
  },
];

// 一级路由
const routes = [
  {
    path: '/',
    component: () => <Navigate to="/login" />,
  },
  {
    path: '/register',
    name: 'register',
    component: lazy(() => import('@/pages/Register')),
  },
  // {
  //   path: '/external',
  //   name: 'external',
  //   component: lazy(() => import('@/pages/External')),
  // }, {
  //   path: '/freeLogin',
  //   name: 'freeLogin',
  //   component: lazy(() => import('@/pages/FreeLogin')),
  // },
  {
    path: '/home',
    name: 'home',
    component: lazy(() => import('@/pages/Layout')),
    children: [
      {
        path: '/home',
        name: 'homeChildren',
        component: () => <Navigate to="/home/industry/industryAnalysis/industryChainGraph?title=产业链" />,
      },
      {
        path: '/home/dict',
        name: 'dict',
        rule: true,
        component: lazy(() => import('@/pages/Dict')),
      },
      {
        path: '/home/homeSearch',
        name: 'homeSearch',
        rule: true,
        component: lazy(() => import('@/pages/HomeSearch')),
        children: [],
      },
      {
        path: '/home/daily',
        name: 'daily',
        rule: true,
        component: lazy(() => import('@/pages/Daily')),
        children: [],
      },
      {
        path: '/home/industry',
        name: 'industry',
        rule: true,
        component: lazy(() => import('@/pages/Industry')),
        children: productRoutes,
      }, {
        path: '/home/city',
        name: 'city',
        rule: true,
        component: lazy(() => import('@/pages/City')),
        children: cityRoutes,
      }, {
        path: '/home/report',
        name: 'report',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Report')),
      }, {
        path: '/home/companyDetails',
        name: 'report',
        rule: true,
        component: lazy(() => import('@/pages/CompanyDetails')),
      }, {
        path: '/home/riskDetails',
        name: 'riskDetails',
        rule: true,
        component: lazy(() => import('@/pages/RiskDetails')),
      }, {
        path: '/home/tool',
        name: 'tool',
        rule: true,
        component: lazy(() => import('@/pages/Tool')),
      },
      {
        path: '/home/tool/riskMonitor',
        name: 'riskMonitor',
        rule: true,
        component: lazy(() => import('@/pages/Tool/RiskMonitor')),
      }, {
        path: '/home/tool/migrationMonitoring',
        name: 'cityTool',
        rule: true,
        component: lazy(() => import('@/pages/Tool/MigrationMonitoring')),
      }, {
        path: '/home/tool/industryPortrait',
        name: 'industryPortrait',
        rule: true,
        component: lazy(() => import('@/pages/Tool/IndustryPortrait')),
      }, {
        path: '/home/tool/shortPlateDiagnosis',
        name: 'toolShortPlateDiagnosis',
        rule: true,
        component: lazy(() => import('@/pages/Tool/ShortPlateDiagnosis')),
      }, {
        path: '/home/tool/targetMerchants',
        name: 'toolTargetMerchants',
        rule: true,
        component: lazy(() => import('@/pages/Tool/TargetMerchants')),
      }, {
        path: '/home/tool/technologyForesight',
        name: 'technologyForesight',
        rule: true,
        component: lazy(() => import('@/pages/Tool/TechnologyForesight')),
      }, {
        path: '/home/tool/consultingService',
        name: 'consultingService',
        rule: true,
        component: lazy(() => import('@/pages/Tool/ConsultingService')),
      },
      {
        path: '/home/tool/contrastIndex',
        name: 'toolContrastIndex',
        rule: true,
        component: lazy(() => import('@/pages/Tool/ContrastIndex')),
      },
      {
        path: '/home/tool/colonyPerspective',
        name: 'colonyPerspective',
        rule: true,
        component: lazy(() => import('@/pages/Tool/ColonyPerspective')),
      },
      {
        path: '/home/tool/cityTool',
        name: 'cityTool',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CityTool')),
      },
      {
        path: '/home/tool/firmComparison',
        name: 'firmComparison',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/FirmComparison')),
      }, {
        path: '/home/tool/firmComparison/collect',
        name: 'firmComparisonCollect',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/FirmComparison/components/Collect')),
      }, {
        path: '/home/tool/searchCompanyMap',
        name: 'searchCompanyMap',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/SearchCompanyMap')),
      }, {
        path: '/home/tool/anchorExpande',
        name: 'anchorExpande',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/AnchorExpande')),
      }, {
        path: '/home/tool/companyTest',
        name: 'companyTest',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CompanyTest')),
      }, {
        path: '/home/tool/companyTest/companyInfo',
        name: 'companyInfo',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CompanyTest/CompanyInfo')),
      }, {
        path: '/home/tool/companyTest/testResult',
        name: 'testResult',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CompanyTest/TestResult')),
      }, {
        path: '/home/tool/companyTest/evaluationRecord',
        name: 'evaluationRecord',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CompanyTest/EvaluationRecord')),
      }, {
        path: '/home/tool/technologyWarning',
        name: 'technologyWarning',
        rule: true,
        component: lazy(() => import('@/pages/Tool/TechnologyWarning')),
      }, {
        path: '/home/tool/valuationModel',
        name: 'valuationModel',
        rule: true,
        component: lazy(() => import('@/pages/Tool/ValuationModel')),
      }, {
        path: '/home/tool/companyIntelligentEvaluation',
        name: 'companyIntelligentEvaluation',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation')),
        children: [
          {
            path: '/home/tool/companyIntelligentEvaluation',
            name: 'companyIntelligentEvaluationChildren',
            component: () => <Navigate to="/home/tool/companyIntelligentEvaluation/evaluation" />,
          },
          {
            path: '/home/tool/companyIntelligentEvaluation/evaluation',
            name: 'evaluation',
            rule: true,
            component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation/components/Evaluation')),
          },
          {
            path: '/home/tool/companyIntelligentEvaluation/details',
            name: 'details',
            rule: true,
            component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation/components/Details')),
          }, {
            path: '/home/tool/companyIntelligentEvaluation/basicInformation',
            name: 'basicInformation',
            rule: true,
            component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation/components/BasicInformation')),
          }, {
            path: '/home/tool/companyIntelligentEvaluation/evaluationResult',
            name: 'evaluationResult',
            rule: true,
            component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation/components/EvaluationResult')),
          }, {
            path: '/home/tool/companyIntelligentEvaluation/filesRecording',
            name: 'filesRecording',
            rule: true,
            component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation/components/FilesRecording')),
          }, {
            path: '/home/tool/companyIntelligentEvaluation/previewPdf',
            name: 'previewPdf',
            rule: true,
            component: lazy(() => import('@/pages/OldFiles/Tool/CompanyIntelligentEvaluation/components/PreviewPdf')),
          },
        ],
      }, {
        path: '/home/tool/industryChainAdvantageEnterprise',
        name: 'industryChainAdvantageEnterprise',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/PenetrateGraph/IndustryChainAdvantageEnterprise')),
      }, {
        path: '/home/tool/largeEnterpriseBusinessLayout',
        name: 'largeEnterpriseBusinessLayout',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/PenetrateGraph/LargeEnterpriseBusinessLayout')),
      }, {
        path: '/home/tool/largeEnterpriseRegionLayout',
        name: 'largeEnterpriseRegionLayout',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/PenetrateGraph/LargeEnterpriseRegionLayout')),
      }, {
        path: '/home/tool/regionCapitalTrend',
        name: 'regionCapitalTrend',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/PenetrateGraph/RegionCapitalTrend')),
      }, {
        path: '/home/tool/city/comparison/table',
        name: 'comparison',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/CityTool/IndustryMonitor/CityComparison/CollectTable')),
      }, {
        path: '/home/tool/marketForecast',
        name: 'marketForecast',
        rule: true,
        component: lazy(() => import('@/pages/Tool/MarketForecast')),
      },
      {
        path: '/home/myself',
        name: 'myself',
        rule: true,
        component: lazy(() => import('@/pages/Myself')),
        children: [
          {
            path: '/home/myself',
            name: 'myselfChildren',
            component: () => <Navigate to="/home/myself/download" />,
          },
          {
            path: '/home/myself/download',
            name: 'download',
            component: lazy(() => import('@/pages/Myself/Right/Download')),
          },
          {
            path: '/home/myself/attention',
            name: 'attention',
            component: lazy(() => import('@/pages/Myself/Right/Attention')),
          },
        ],
      },
      {
        path: '/home/dataSearch',
        name: 'dataSearch',
        // component: () => <Navigate to="/home/dataSearch/all" />,
        component: lazy(() => import('@/pages/SearchDetails')),
        rule: true,
        children: [
          {
            path: '/home/dataSearch/all',
            name: 'dataSearchAll',
            component: lazy(() => import('@/pages/SearchDetails/Right')),
          }, {
            path: '/home/dataSearch/company',
            name: 'dataSearchCompany',
            component: lazy(() => import('@/pages/SearchDetails/Right/Company')),
          }, {
            path: '/home/dataSearch/patent',
            name: 'dataSearchPatent',
            component: lazy(() => import('@/pages/SearchDetails/Right/Patent')),
          }, {
            path: '/home/dataSearch/investment',
            name: 'dataSearchInvestment',
            component: lazy(() => import('@/pages/SearchDetails/Right/Investment')),
          }, {
            path: '/home/dataSearch/academy',
            name: 'dataSearchAcademy',
            component: lazy(() => import('@/pages/SearchDetails/Right/Academy')),
          }, {
            path: '/home/dataSearch/garden',
            name: 'dataSearchGarden',
            component: lazy(() => import('@/pages/SearchDetails/Right/Garden')),
          }, {
            path: '/home/dataSearch/policy',
            name: 'dataSearchPolicy',
            component: lazy(() => import('@/pages/SearchDetails/Right/Policy')),
          }, {
            path: '/home/dataSearch/researchReport',
            name: 'dataSearchResearchReport',
            component: lazy(() => import('@/pages/SearchDetails/Right/ResearchReport')),
          },
        ],
      },
    ],
  },
  // {
  //   path: '/devLogin',
  //   name: 'devLogin',
  //   component: lazy(() => import('@/pages/DevLogin')),
  // },
  {
    path: '/login',
    name: 'login',
    component: lazy(() => import('@/pages/Login')),
  },
  {
    path: '/companyDetails',
    name: 'companyDetails',
    rule: true,
    component: lazy(() => import('@/pages/CompanyDetails')),
  }, {
    path: '/report/Migration',
    name: 'report',
    rule: true,
    component: lazy(() => import('@/pages/Report/Migration')),
  }, {
    path: '/reportDownLoad',
    name: 'reportDownLoad',
    rule: true,
    component: lazy(() => import('@/pages/OldFiles/components/ReportDownLoad')),
  },
  {
    path: '/scheme',
    name: 'scheme',
    component: lazy(() => import('@/pages/OldFiles/Scheme')),
  },
  {
    path: '/reportPreview',
    name: 'reportPreview',
    component: lazy(() => import('@/pages/OldFiles/RegionalPortraitReport')),
  }, {
    path: '/standardDetail',
    name: 'standardDetail',
    component: lazy(() => import('@/pages/OldFiles/Standard/StandardDetail')),
  }, {
    path: '/companyReport',
    name: 'companyReport',
    component: lazy(() => import('@/pages/OldFiles/CompanyAnnualReport')),
  }, {
    path: '/patentDetail',
    name: 'patentDetail',
    component: lazy(() => import('@/pages/OldFiles/IndustryPatentDetail')),
  }, {
    path: '/investmentDetail',
    name: 'investmentDetail',
    component: lazy(() => import('@/pages/OldFiles/InvestmentEventDetail')),
  },
  {
    path: 'dataAnalysisTool',
    name: 'dataAnalysisTool',
    component: lazy(() => import('@/pages/OldFiles/Tool/DataAnalysisTool/pages/DataAnalysis')),
    children: [
      {
        path: '/dataAnalysisTool',
        name: 'dataAnalysisToolChildren',
        component: () => <Navigate to="/dataAnalysisTool/dataFilter" />,
      },
      {
        path: '/dataAnalysisTool/dataFilter',
        name: 'dataFilter',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/DataAnalysisTool/pages/DataFilter')),
      }, {
        path: '/dataAnalysisTool/myReport',
        name: 'myReport',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/DataAnalysisTool/pages/MyReport')),
      }, {
        path: '/dataAnalysisTool/downloadList',
        name: 'downloadList',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/DataAnalysisTool/pages/DownloadList')),
      }, {
        path: '/dataAnalysisTool/chartTableTool',
        name: 'chartTableTool',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/DataAnalysisTool/pages/ChartTableTool')),
      }, {
        path: '/dataAnalysisTool/reportPreview',
        name: 'reportPreview',
        rule: true,
        component: lazy(() => import('@/pages/OldFiles/Tool/DataAnalysisTool/pages/ReportPreview')),
      },
    ],
  },
  {
    path: '*',
    component: () => (
      <Result
        status="404"
        title="404"
        subTitle="对不起, 你访问的页面不存在！"
      />
    ),
  },
];

export default routes;
